/**
 * A directive that preserves focus on a particular element between state changes.
 */
export function StatePreserveFocusDirective($timeout, $transitions) {
    'ngInject';
    return {
        restrict: "A",
        link: function (scope, el, attr) {
            let focusedElement = null;
            const unregisterOnCreate = $transitions.onCreate({}, () => {
                const id = el[0].id;
                const activeElement = document.activeElement;
                if (!id || activeElement.id !== id) {
                    focusedElement = null;
                    return;
                }
                focusedElement = { id };
                // Get element textbox selection.
                try {
                    focusedElement.selectionStart = activeElement.selectionStart;
                    focusedElement.selectionEnd = activeElement.selectionEnd;
                } catch (ex) {
                    focusedElement.selectionStart = null;
                }
                activeElement.blur();
            });
            const unregisterRestore = $transitions.onSuccess({}, () => {
                unregisterOnCreate();
                unregisterRestore();
                $timeout(() => {
                    if (!focusedElement) {
                        return;
                    }
                    const newElement = document.querySelector(`#${focusedElement.id}`);
                    if (!newElement || !newElement.focus) {
                        return;
                    }
                    newElement.selectionStart = focusedElement.selectionStart;
                    newElement.selectionEnd = focusedElement.selectionEnd;
                    newElement.focus();
                })
            });
        }
    }
}
